import { Expose, plainToInstance } from "class-transformer";
import {
  IsDate,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
} from "class-validator";

export enum ProductType {
  PACKAGE = "PACKAGE",
  ADD_ON = "ADD_ON",
  UPGRADE = "UPGRADE",
  ADDITIONAL_REVISION = "ADDITIONAL_REVISION",
}

export enum PackageType {
  FRONT_YARD = "FRONT_YARD",
  BACK_YARD = "BACK_YARD",
  FULL_YARD = "FULL_YARD",
  UBER_PREMIUM = "UBER_PREMIUM",
  BOTANICAL = "BOTANICAL",
  CURB_APPEAL = "CURB_APPEAL",
  WHOLE_HOME = "WHOLE_HOME",
  FRONT_YARD_ESSENTIAL = "FRONT_YARD_ESSENTIAL",
  FRONT_YARD_CLASSIC = "FRONT_YARD_CLASSIC",
  FRONT_YARD_SIGNATURE = "FRONT_YARD_SIGNATURE",
  BACK_YARD_ESSENTIAL = "BACK_YARD_ESSENTIAL",
  BACK_YARD_CLASSIC = "BACK_YARD_CLASSIC",
  BACK_YARD_SIGNATURE = "BACK_YARD_SIGNATURE",
  FULL_YARD_ESSENTIAL = "FULL_YARD_ESSENTIAL",
  FULL_YARD_CLASSIC = "FULL_YARD_CLASSIC",
  FULL_YARD_SIGNATURE = "FULL_YARD_SIGNATURE",
  AREA_ESSENTIAL = "AREA_ESSENTIAL",
  AREA_CLASSIC = "AREA_CLASSIC",
  AREA_SIGNATURE = "AREA_SIGNATURE",
  PREMIUM_SIGNATURE = "PREMIUM_SIGNATURE",
  CALIFORNIA_FIRESCAPING_CLASSIC = "CALIFORNIA_FIRESCAPING_CLASSIC",
  PARTIAL_YARD = "PARTIAL_YARD",
  FRONT_OR_BACKYARD_STARTER = "FRONT_OR_BACKYARD_STARTER",
  SMALL_SPACE = "SMALL_SPACE",
  ENTIRE_YARD_STARTER = "ENTIRE_YARD_STARTER",
}

export enum AddOnType {
  EXTERIOR = "EXTERIOR",
  EXPEDITED = "EXPEDITED",
  HOA = "HOA",
}

export enum LotSize {
  STANDARD = "STANDARD",
  LARGE = "LARGE",
}

export class Product {
  public static from(product: Product) {
    return plainToInstance(Product, product, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  sku!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  name!: string;

  @Expose()
  @IsEnum(ProductType)
  productType!: ProductType;

  @Expose()
  @IsOptional()
  @IsEnum(PackageType)
  packageType?: PackageType;

  @Expose()
  @IsOptional()
  @IsEnum(AddOnType)
  addOnType?: AddOnType;

  @Expose()
  @IsOptional()
  @IsEnum(LotSize)
  lotSize?: LotSize;

  @Expose()
  @IsOptional()
  @IsString()
  designProjectId?: string;

  @Expose()
  @IsInt()
  price!: number;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;
}
